<template>
<div id="instPreWin" v-bind:class="{alarmClient:!calcVirginDraft}">
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-if="calcVirginDraft" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.267.108a.729.729 0 011.006.244c.567.948.84 3.048-1.328 4.855a.74.74 0 01-1.036-.098.743.743 0 01.098-1.035c1.582-1.319 1.22-2.608 1.006-2.96a.743.743 0 01.254-1.006zm5.587 4.073a.737.737 0 000-1.035.737.737 0 00-1.035 0l-2.93 2.93a.737.737 0 000 1.036.737.737 0 001.035 0l2.93-2.93zm-6.476 3.556l1.885 1.885c.909.918 1.66 1.66 2.14 2.305.497.674.83 1.387.673 2.207-.146.821-.713 1.368-1.416 1.817-.694.44-1.65.87-2.833 1.387l-3.35 1.495c-1.983.879-3.555 1.572-4.747 1.914-1.162.342-2.305.44-3.106-.371-.81-.801-.713-1.944-.371-3.106.342-1.192 1.035-2.764 1.914-4.747L3.632 9.23l.03-.058c.517-1.182.947-2.14 1.387-2.833.449-.703.996-1.27 1.817-1.416.82-.157 1.533.175 2.207.674.645.478 1.387 1.23 2.305 2.139zM8.194 6.77c-.537-.4-.83-.45-1.065-.41-.234.048-.488.195-.85.771-.214.342-.44.782-.693 1.338.02.01.039.03.059.05l6.837 6.836s.039.04.049.059a11.67 11.67 0 001.338-.694c.576-.36.723-.615.771-.85.04-.234-.01-.527-.41-1.064-.41-.557-1.084-1.22-2.05-2.188l-1.798-1.797C9.415 7.854 8.75 7.18 8.194 6.77zm-4.66 6.29l1.407-3.174 6.173 6.173-3.174 1.406-.186.078a.586.586 0 00-.156-.234l-3.907-3.907a.586.586 0 00-.234-.156l.078-.186zm-.693 1.563l3.536 3.536c-1.27.556-2.266.957-3.047 1.182-1.124.322-1.495.185-1.67 0-.186-.176-.323-.547 0-1.67.224-.782.625-1.778 1.181-3.048zm17.807-6.896c-.948-.567-3.048-.84-4.855 1.328a.74.74 0 00.098 1.036.74.74 0 001.035-.098c1.319-1.582 2.608-1.22 2.96-1.006a.74.74 0 001.006-.254.729.729 0 00-.244-1.006zM16.36.001c.4 0 .732.332.732.732v.02c0 .4-.332.732-.732.732a.738.738 0 01-.733-.732v-.02c0-.4.332-.732.733-.732zM21 4.64c0-.401-.333-.733-.733-.733-.4 0-.733.332-.733.732v.02c0 .4.332.732.733.732.4 0 .732-.332.732-.732v-.02zm-1.71 6.104c.4 0 .732.332.732.733v.02c0 .4-.332.732-.732.732a.738.738 0 01-.733-.733v-.02c0-.4.332-.732.733-.732zM10.255 1.71c0-.4-.332-.732-.733-.732-.4 0-.732.332-.732.732v.02c0 .4.332.732.732.732.4 0 .733-.332.733-.732v-.02z" fill="#005640"/></svg>
  <p id="alarm" v-if="!calcVirginDraft">!</p>
  <div v-if="calcVirginDraft">
    <h4>Поздравляем! Ваша заявка предварительно одобрена</h4>
    <p>Подтвердите личность и получите деньги!</p>
  </div>
  <div v-else >
    <h4>Внесите изменения в документы.</h4>
    <p>{{demandState.comment}}</p>
  </div>
</div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "instPreWin",
  data() {
    return {
      isFirstVisit: false,
    }
  },
  mounted() {
    const key = `passportDone_${window.session_id}`;
    if (localStorage.getItem(key)) {
      this.isFirstVisit = true;
      localStorage.removeItem(key);
    }
  },
  computed: {
    ...mapState({
      demandState: state => state.instForm.demandState,
    }),
    calcVirginDraft(){
      if (this.isFirstVisit) return true;
      return (this.demandState.allPhotosStatusList.passport1 +
              this.demandState.allPhotosStatusList.passport2 +
              this.demandState.allPhotosStatusList.passport3 +
              this.demandState.allPhotosStatusList.selfImage +
              this.demandState.allPhotosStatusList.BankAccount) === 0;
    }
  }
}
</script>

<style scoped>
#instPreWin{border-radius: var(--font-size-04);background: var(--color-green-light);
padding:var(--font-size-16) var(--font-size-08);display: flex;align-items: flex-start;justify-content: flex-start;
  color:var(--color-dark-green);margin: var(--font-size-16) 0}
#instPreWin img, #instPreWin svg{width: var(--font-size-21);height: var(--font-size-21);margin-right: var(--font-size-16)}
h4{font-weight: 500;font-size: var(--font-size-16);margin: 0}
p{margin: var(--font-size-08) 0;font-size: var(--font-size-16)}
#instPreWin.alarmClient{background: var(--color-red-type2);color:var(--color-red-type1);}
#alarm{font-size: var(--font-size-47);color:var(--color-red-type1);margin: 0 var(--font-size-25)}
</style>